<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded"><span class="epub-i">For</span></p>
<p class="ded">Bernie, Josh and Sara—my own private comedy group</p>
<p class="ded"> </p>
<p class="ded"><span class="epub-i">and</span></p>
<p class="ded">for two people who took personal generosity</p>
<p class="ded-bot">and professional loyalty to astounding extremes,</p>
<p class="ded">Christina McCall and Helga Stephenson</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?0173e648